export * from './air-flow-volumes'
export * from './door-types'
export * from './fireplace-classes'
export * from './fireplace-types'
export * from './room-names'

export const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
